const form = document.querySelector(".blog-bar__search-form");

if (form) {
  form.addEventListener("submit", (event) => {
    event.preventDefault();

    const action = form.getAttribute("action") || window.location.href;
    const url = new URL(action, window.location.origin);
    const input = form.querySelector("[name='s']");
    const term = input instanceof HTMLInputElement ? input.value.trim() : "";

    if (term === "") {
      const resetUrl = form.getAttribute("data-reset-url");

      if (resetUrl) {
        window.location.assign(resetUrl);
        return;
      }

      url.searchParams.delete("s");
    } else {
      url.searchParams.set("s", term);
    }

    url.hash = "blog-posts";
    window.location.assign(url.toString());
  });
}
